import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=23b4f162"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports